import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SliderModule } from '@syncfusion/ej2-angular-inputs';
import { StepperAllModule, StepperModule } from '@syncfusion/ej2-angular-navigations';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { FastCheckInStepUserInfoComponent } from '../fast-checkin/shared/fast-check-in-step-user-info/fast-checkin-step-user-info.component';
import { FastCheckinType, ParkingProcessZoneInfoDTO, ParkingSessionControlType } from 'src/app/base/models/models.swagger.generated';
import { QueryParameter } from 'src/app/base/query-parameters';
import { FastCeckinUserInfoFormType } from '../fast-checkin/shared/fast-check-in-step-user-info/fast-checkin-user-info-form';
import { ActivatedRoute } from '@angular/router';
import { MobileLandingService } from '../mobile-landing/mobile-landing.service';
import { PayTillNowStepPayNowComponent } from './pay-till-now-step-pay-now/pay-till-now-step-pay-now.component';
import { MobileHeaderComponent } from '../mobile-landing/shared/mobile-header/mobile-header.component';

@Component({
  selector: 'app-pay-till-now',
  imports: [TranslateModule, ReactiveFormsModule, SliderModule, StepperAllModule, StepperModule, TooltipModule, FastCheckInStepUserInfoComponent, PayTillNowStepPayNowComponent, MobileHeaderComponent],
  templateUrl: './pay-till-now.component.html',
  styleUrl: './pay-till-now.component.scss',
})
export class PayTillNowComponent implements OnInit {
  public get zoneName(): string {
    return this.zoneInfo?.name ?? '';
  }

  public get controlPlate(): string {
    return this.userInfoForm?.controls.controlPlate?.value;
  }

  public fastCheckinType = FastCheckinType.PayTillNow;
  public errorMessage: string = 'i18n.domain.fast-checkin.errors.zoneNotFound';
  public stepIndex = 0;
  public zoneInfo: ParkingProcessZoneInfoDTO | null = null;
  public userInfoForm: FormGroup<FastCeckinUserInfoFormType>;
  public showError = false;
  public validatingParkerId?: number = undefined;

  constructor(
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private mobileLandingService: MobileLandingService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const zoneId = params[QueryParameter.ZoneId];
      this.validatingParkerId = params[QueryParameter.ParkerId];
      this.mobileLandingService.fetchParkingProcessZoneInfo(zoneId).subscribe({next:zoneInfo => {
        this.zoneInfo = zoneInfo;
          if (!this.zoneInfo || (this.zoneInfo.sessionControlType !== ParkingSessionControlType.HardwareControlled)) {
            this.errorMessage = 'i18n.domain.fast-checkin.errors.zoneNotFound';
            this.showError = true;
          }
        },
        error: err => {
          this.errorMessage = 'i18n.domain.fast-checkin.errors.zoneNotFound';
          this.showError = true;
        }}
      );
    });

    this.renderer.addClass(document.body, 'body-login');
  }

  public onUserInfoNext(userInfoForm: FormGroup<FastCeckinUserInfoFormType>) {
    this.userInfoForm = userInfoForm;
    this.stepIndex = 1;
  }

  public onBack() {
    this.stepIndex = 0;
  }
}
